(() => {
  const VARIANT_ID = 52352165249360;
  const CHECKBOX_SELECTOR = '#CartDrawerGiftWrap';

  async function cart() {
    const r = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!r.ok) throw new Error('cart.js failed');
    return r.json();
  }

  function hasGiftWrap(c) {
    return c.items?.some(i => Number(i.variant_id) === Number(VARIANT_ID));
  }

  async function addGiftWrap() {
    // Form-encoded is the most compatible with themes/apps
    const body = new URLSearchParams();
    body.set('id', String(VARIANT_ID));
    body.set('quantity', '1');

    const r = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
      body
    });

    if (!r.ok) {
      const t = await r.text();
      throw new Error(`add.js failed (${r.status}): ${t}`);
    }
  }

  async function removeGiftWrap() {
    const r = await fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: VARIANT_ID, quantity: 0 })
    });

    if (!r.ok) {
      const t = await r.text();
      throw new Error(`change.js failed (${r.status}): ${t}`);
    }
  }

  function refreshMotionDrawer() {
    // Motion/Archetype commonly listens to these
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:updated'));
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  }

  async function syncCheckbox(cb) {
    const c = await cart();
    cb.checked = hasGiftWrap(c);
  }

  async function onChange(e) {
    const cb = e.currentTarget;
    cb.disabled = true;

    try {
      const c = await cart();
      const exists = hasGiftWrap(c);

      if (cb.checked && !exists) await addGiftWrap();
      if (!cb.checked && exists) await removeGiftWrap();

      refreshMotionDrawer();

      // drawer often re-renders async — sync after a short tick
      await new Promise(r => setTimeout(r, 250));
      const cb2 = document.querySelector(CHECKBOX_SELECTOR);
      if (cb2) await syncCheckbox(cb2);
    } catch (err) {
      console.error('[Giftwrap]', err);
      // revert checkbox to real cart state
      try {
        const cb2 = document.querySelector(CHECKBOX_SELECTOR);
        if (cb2) await syncCheckbox(cb2);
      } catch {}
      alert('Geschenkverpackung konnte nicht hinzugefügt werden. (Details in Console)');
    } finally {
      cb.disabled = false;
    }
  }

  function bind() {
    const cb = document.querySelector(CHECKBOX_SELECTOR);
    if (!cb) return;

    if (!cb.dataset.giftwrapBound) {
      cb.addEventListener('change', onChange);
      cb.dataset.giftwrapBound = '1';
    }

    syncCheckbox(cb).catch(() => {});
  }

  // Initial
  document.addEventListener('DOMContentLoaded', bind);
  document.addEventListener('shopify:section:load', bind);

  // Re-bind after Motion updates cart/drawer
  document.addEventListener('cart:updated', bind);

  // Extra safety: if drawer HTML is replaced, re-bind via mutation
  const mo = new MutationObserver(() => bind());
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
